import { computed } from 'vue';

import useAuth from '@/composables/useAuth';
import { useIntegrationProfileStore } from '@/stores';
import { API_FILTER_INTEGRATION_TYPE } from '@/types/integration_profiles';

export default function useApiFilterCreateGate() {
  const integrationProfileStore = useIntegrationProfileStore();
  const { hasPermission } = useAuth();

  const canWrite = computed(() => hasPermission('manage:integrations'));

  const filterCount = computed(
    () =>
      integrationProfileStore.getIntegrationProfilesByType(
        API_FILTER_INTEGRATION_TYPE,
      ).length,
  );

  const createDisabledReason = computed(() =>
    canWrite.value ? undefined : 'Your role cannot create API filters.',
  );

  return { canWrite, filterCount, createDisabledReason };
}
